/** The logo stone's letters when there is no logo image: the first letters of the first two words. */
export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter((w) => /^[\p{L}\p{N}]/u.test(w))
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('') || name.slice(0, 1).toUpperCase();
